import { AfterViewInit, Component } from '@angular/core';
import { HelperService } from '../../helper.service';
import { AbstractPageForm } from '../../pages/page-form.abstract';

// eslint-disable-next-line @typescript-eslint/naming-convention
declare let Stripe;

@Component({
	selector: 'pk-broker-stripe-card-element',
	standalone: false,
	templateUrl: './stripe-card-element.component.html',
	styleUrl: './stripe-card-element.component.scss',
})
export class StripeCardElementComponent extends AbstractPageForm implements AfterViewInit {
	private stripe = Stripe(this.environment.stripeKey);
	public creditCard: any;
	public cardErrorMessage: string;

	constructor(private helperService: HelperService) {
		super();
	}

	public async createToken(): Promise<string> {
		try {
			const cardRes = await this.stripe.createToken(this.creditCard);
			if (cardRes.error) {
				this.cardErrorMessage = cardRes.error.message;
			} else {
				return cardRes.token.id;
			}
		} catch (e) {
			this.cardErrorMessage = `There was a problem creating the card, please contact support.`;
		}
	}

	public ngAfterViewInit(): void {
		const elements = this.stripe.elements();
		this.creditCard = elements.create('card');
		this.creditCard.mount('#card-element');
		this.creditCard.addEventListener('change', (event: any) => {
			this.cardErrorMessage = event.error?.message ?? '';
		});
	}
}
